<mat-sidenav-container autosize="true">
    <mat-sidenav #sidenav mode="side" opened="true" class="mat-sidenav" [ngClass]="{ 'mat-sidenav-expanded': isExpanded }">
        <mat-nav-list style="height: 100%;overflow-y: hidden;">
            <div class="list">
              <div>
                <mat-list-item style="margin-bottom: 11px; margin-top: 3px">
                  <img src="/assets/HyperDriveLogo.png" class="logo" *ngIf="isExpanded"/>
                  <img src="/assets/App icon.png" class="logo-small" *ngIf="!isExpanded"/>
        </mat-list-item>
              </div>
                <div class="side">


          <mat-list-item
            [routerLink]="'dashboard'"
            routerLinkActive="active1"
            class="listitem"
          >
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/ic_dashboard.svg"
                style="height: 20px; width: 21px; margin-left: 5px"
            /></span>
                        <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Dashboard</span
            >
          </mat-list-item>
          <mat-list-item
            [routerLink]="'customer'"
            [ngClass]="{ 'active': isPageActive('customer')}"
            routerLinkActive="active1"
            class="listitem"
            *ngIf="!hasNoAuthorityForModule('Customer')"
          >
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/customer-d.svg"
                style="height: 20px; width: 21px; margin-left: 5px"
            /></span>
                        <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']"
                        >Customer</span
            >
          </mat-list-item>

          <mat-list-item
            [routerLink]="'driverlist'"
            [ngClass]="{ 'active': isPageActive('driverlist')}"
            routerLinkActive="active1"
            class="listitem"
            *ngIf="!hasNoAuthorityForModule('Driver')"
          >
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/ic_driver.svg"
                style="height: 20px; width: 21px; margin-left: 5px"
            /></span>
                        <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Driver</span
            >
          </mat-list-item>
          <!-- settings -->
          <mat-list-item
            routerLinkActive="active1"
            class="listitem"
            (click)="showSubSubmenupayment()"
            *ngIf="!hasNoAuthorityForModule('Settings')"
          >
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/ic_setting.svg"
                style="height: 20px; width: 21px; margin-left: 5px"
              />
            </span>
                        <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Settings</span
            >
            <span
              class="material-symbols-outlined"
              style="margin-left: 20px;color: darkgray;"
              *ngIf="showSubSubMenuPayment == true && isExpanded"
            >
              expand_more
            </span>
                        <span class="material-symbols-outlined" style="margin-left: 20px;color: darkgray;" *ngIf="showSubSubMenuPayment == false && isExpanded">
              chevron_right
            </span>
                    </mat-list-item>
                    <div class="submenu" [ngClass]="{ expanded: showSubSubMenuPayment }" *ngIf="showSubSubMenuPayment && isExpanded">
                        <!-- <mat-list-item [routerLink]="'settings'" routerLinkActive="active1">
                            <div style="margin-left: 14px">
                                <span class="icons" [routerLinkActive]="['active-item']">
                  <img
                    src="/assets/ridee.svg"
                    style="height: 20px; width: 21px; margin-left: 5px"
                /></span>
                  <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Ride Type</span>
              </div>
            </mat-list-item> -->
            <mat-list-item
              [routerLink]="'vehicletype'"
              routerLinkActive="active1"
            >
              <div style="margin-left: 14px">
                <span class="icons" [routerLinkActive]="['active-item']">
                  <img
                    src="/assets/vehicle.svg"
                    style="height: 20px; width: 21px; margin-left: 5px"
                /></span>
                                <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Vehicle Type</span
                >
              </div>
            </mat-list-item>
            <mat-list-item [routerLink]="'vehicle-category'" routerLinkActive="active1">
              <div style="margin-left: 14px">
                <span class="icons" [routerLinkActive]="['active-item']">
                  <img
                    src="/assets/ridee.svg"
                    style="height: 20px; width: 21px; margin-left: 5px"
                /></span>
                <span
                  *ngIf="isExpanded"
                  class="dashboardmenu"
                  [routerLinkActive]="['active-item']"
                  >Rental Category</span
                >
              </div>
            </mat-list-item>
            <mat-list-item [routerLink]="'rental-vehicle'" routerLinkActive="active1">
              <div style="margin-left: 14px">
                <span class="icons" [routerLinkActive]="['active-item']">
                  <img
                    src="/assets/vehicle.svg"
                    style="height: 20px; width: 21px; margin-left: 5px"
                /></span>
                <span
                  *ngIf="isExpanded"
                  class="dashboardmenu"
                  [routerLinkActive]="['active-item']"
                  >Rental Vehicle</span
                >
              </div>
            </mat-list-item>
          </div>
          <!-- cancel -->
          <mat-list-item
            [routerLink]="'Cancel'"
            routerLinkActive="active1"
            class="listitem"
            *ngIf="!hasNoAuthorityForModule('Cancel reason')"

          >
            <!-- <mat-icon mat-list-icon class="">cancel</mat-icon> -->
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/ic_cancel.svg"
                style="height: 20px; width: 21px; margin-left: 5px"
            /></span>
                                <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Cancel Reason</span
            >
          </mat-list-item>
          <!-- <mat-list-item
          [routerLink]="'reason'"
          [ngClass]="{ 'active': isPageActive('customer')}"
          routerLinkActive="active1"
          class="listitem"
        >
          <span class="icons" [routerLinkActive]="['active-item']">
            <img
              src="/assets/help&support grey (1).svg"
              style="height: 20px; width: 21px; margin-left: 5px"
          /></span>
                      <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Consumer Issues</span
          >
        </mat-list-item> -->
          <mat-list-item
            [routerLink]="'SubAdmin'"
            [ngClass]="{ 'active': isPageActive('SubAdmin')}"
            routerLinkActive="active1"
            class="listitem"

            *ngIf="!hasNoAuthorityForModule('Sub-admin')"

          >
            <!-- <mat-icon mat-list-icon class="">person</mat-icon> -->
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/ic_sub_admin.svg"
                style="height: 20px; width: 21px; margin-left: 5px"
            /></span>
                                <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Sub-Admin</span
            >
          </mat-list-item>

        <!-- Rides -->
        <mat-list-item
        routerLinkActive="active1"
        class="listitem"
        (click)="showRidesSubMenu()"
        *ngIf="!hasNoAuthorityForModule('Rides')"
      >
        <span class="icons" [routerLinkActive]="['active-item']">
          <img
            src="/assets/vehicle.svg"
            style="height: 20px; width: 21px; margin-left: 5px"
          />
        </span>
        <span
          *ngIf="isExpanded"
          class="dashboardmenu"
          [routerLinkActive]="['active-item']"
          >Rides</span
        >
        <span
          class="material-symbols-outlined"
          style="margin-left: 20px; color: darkgray"
          *ngIf="ridesSubMenu == true && isExpanded"
        >
          expand_more
        </span>
        <span
          class="material-symbols-outlined"
          style="margin-left: 20px; color: darkgray"
          *ngIf="ridesSubMenu == false && isExpanded"
        >
          chevron_right
        </span>
      </mat-list-item>
      <div
        class="submenu"
        [ngClass]="{ expanded: ridesSubMenu }"
        *ngIf="ridesSubMenu && isExpanded"
      >
        <mat-list-item [routerLink]="'completed-rides'" routerLinkActive="active1">
          <div style="margin-left: 14px">
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/vehicle.svg"
                style="height: 20px; width: 21px; margin-left: 5px"
            /></span>
            <span
              *ngIf="isExpanded"
              class="dashboardmenu"
              [routerLinkActive]="['active-item']"
              >Completed Rides</span
            >
          </div>
        </mat-list-item>
        <mat-list-item [routerLink]="'ongoing-rides'" routerLinkActive="active1">
          <div style="margin-left: 14px">
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/ongoing_rides.png"
                style="height: 21px; width: 22px; margin-left: 5px"
            /></span>
            <span
              *ngIf="isExpanded"
              class="dashboardmenu"
              [routerLinkActive]="['active-item']"
              >Ongoing Rides</span
            >
          </div>
        </mat-list-item>
        <mat-list-item [routerLink]="'cancelled-rides'" routerLinkActive="active1">
          <div style="margin-left: 14px">
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/cancelled_rides.png"
                style="height: 21px; width: 22px; margin-left: 5px"
            /></span>
            <span
              *ngIf="isExpanded"
              class="dashboardmenu"
              [routerLinkActive]="['active-item']"
              >Cancelled Rides</span
            >
          </div>
        </mat-list-item>
      </div>
         <!-- End Rides -->
          <mat-list-item
          [routerLink]="'rentals'"
          [ngClass]="{ 'active': isPageActive('SubAdmin')}"
          routerLinkActive="active1"
          class="listitem"

          *ngIf="!hasNoAuthorityForModule('Sub-admin')"

        >
          <!-- <mat-icon mat-list-icon class="">person</mat-icon> -->
          <span class="icons" [routerLinkActive]="['active-item']">
            <img
              src="/assets/rentals.svg"
              style="height: 20px; width: 21px; margin-left: 5px"
          /></span>
                              <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Rentals</span
          >
        </mat-list-item>
                   <!-- Geofence -->
                   <mat-list-item
                   routerLinkActive="active1"
                   class="listitem"
                   (click)="showGeofenceSubMenu()"
                   *ngIf="!hasNoAuthorityForModule('geofence')"
                 >
                   <span class="icons" [routerLinkActive]="['active-item']">
                     <img
                       src="/assets/location.svg"
                       style="height: 20px; width: 21px; margin-left: 5px"
                     />
                   </span>
                               <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Geo-Fences</span
                   >
                   <span
                     class="material-symbols-outlined"
                     style="margin-left: 20px;color: darkgray;"
                     *ngIf="geofenceSubMenu == true && isExpanded"
                   >
                     expand_more
                   </span>
                               <span class="material-symbols-outlined" style="margin-left: 20px;color: darkgray;" *ngIf="geofenceSubMenu == false && isExpanded">
                                 chevron_right
                   </span>
                           </mat-list-item>
                           <div class="submenu" [ngClass]="{ expanded: showSubSubMenuPayment }" *ngIf="geofenceSubMenu && isExpanded">
                               <mat-list-item [routerLink]="'polygon'" routerLinkActive="active1">
                                   <div style="margin-left: 14px">
                                       <span class="icons" [routerLinkActive]="['active-item']">
                         <img
                           src="/assets/geofence.svg"
                           style="height: 20px; width: 21px; margin-left: 5px"
                       /></span>
                                       <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Operating Zones</span
                       >
                     </div>
                   </mat-list-item>
                   <mat-list-item
                     [routerLink]="'sub-region/list'"
                     routerLinkActive="active1"
                   >
                     <div style="margin-left: 14px">
                       <span class="icons" [routerLinkActive]="['active-item']">
                         <img
                           src="/assets/geofence.svg"
                           style="height: 20px; width: 21px; margin-left: 5px"
                       /></span>
                                       <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Sub Regions</span
                       >
                     </div>
                   </mat-list-item>
                 </div>
                 <!-- End Geofence -->
          <mat-list-item
            [routerLink]="'promo-codes'"
            routerLinkActive="active1"
            [ngClass]="{ 'active': isPageActive('promo-codes')}"
            class="listitem"
            *ngIf="!hasNoAuthorityForModule('Promocode')"
          >
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/ic_promocode.svg"
                style="height: 20px; width: 21px; margin-left: 5px"
              />
            </span>
                                <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Promo-Codes</span
            >
          </mat-list-item>
          <mat-list-item
            [routerLink]="'Notification'"
            routerLinkActive="active1"
            class="listitem"
            *ngIf="!hasNoAuthorityForModule('Notification')"
          >
            <span class="icons" [routerLinkActive]="['active-item']">
              <img
                src="/assets/Path 10500 (1).svg"
                style="height: 20px; width: 21px; margin-left: 5px"
              />
            </span>
                                <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Notification</span
            >
          </mat-list-item>
          <mat-list-item
          [routerLink]="'promotion'"
          routerLinkActive="active1"
          class="listitem"
        >
          <span class="icons" [routerLinkActive]="['active-item']">
            <img
              src="/assets/promotion (1).svg"
              style="height: 20px; width: 21px; margin-left: 5px"
          /></span>
                      <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">promotional Banner</span
          >
        </mat-list-item>
          <mat-list-item
          [routerLink]="'settlements'"
          routerLinkActive="active1"
          class="listitem"
        >
          <span class="icons" [routerLinkActive]="['active-item']">
            <img
              src="/assets/money.svg"
              style="height: 20px; width: 21px; margin-left: 5px"
          /></span>
                      <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Settlements</span
          >
        </mat-list-item>
        <mat-list-item
        [routerLink]="'chat'"
        routerLinkActive="active1"
        class="listitem"
        *ngIf="!hasNoAuthorityForModule('Help & Support')"
      >
        <span class="icons" [routerLinkActive]="['active-item']">
          <img
            src="/assets/help&support grey (1).svg"
            style="height: 20px; width: 21px; margin-left: 5px"
          />
        </span>
                            <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Help and Support</span
        >
      </mat-list-item>
        </div>
        <div style="margin-bottom: 20px">
          <mat-list-item
            routerLinkActive="active1"
            class="listitem"
            (click)="confirmBox()"
          >
            <span class="icons" [routerLinkActive]="['active-item']">
              <div
                style="
                  display: flex;
                  align-items: center;
                  width: 42px;
                  height: 42px;
                  background: #fff1ee 0% 0% no-repeat padding-box;
                  border-radius: 12px;
                "
              >
                <img
                  src="/assets/ic_logout.png"
                  style="
                    height: 20px;

                    margin-left: 8px;
                  "
                />
              </div>
            </span>
                                <span *ngIf="isExpanded" class="dashboardmenu" [routerLinkActive]="['active-item']">Logout</span
            >
          </mat-list-item>
        </div>
      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content
    style="
      overflow-x: hidden;
      overflow-x: hidden;
      min-height: 500px;
      min-height: 500px;
    "
  >
    <mat-toolbar
      style="background: #D9D9D9 0% 0% no-repeat padding-box; opacity: 1"
    >
      <div class="toolbar">
        <div class="bar">
          <mat-list-item (click)="isExpanded = !isExpanded; changeSideNavState()"
            ><img src="/assets/Ic_hamburger.svg"
          /></mat-list-item>
        </div>
        <div class="logoutIcon">
          <ul class="row m-0 align-items-center">
            <li>
              <div style="display: flex">
                <div class="headerName">Welcome {{ name }}</div>
              </div>
              <mat-menu #menu="matMenu"> </mat-menu>
            </li>
          </ul>
        </div>
      </div>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
